/** Typed fetch client for the Yalıda Davet API (shared with apps/mobile). */
import { createApiClient } from '@yalidavet/shared';

export { ApiRequestError as ApiError, toQueryString } from '@yalidavet/shared';
export type { SearchResponse, EventTypeDto } from '@yalidavet/shared';

/**
 * Local-only admin preview: with VITE_ADMIN_SERVICE_TOKEN in .env.local (the
 * same value as ADMIN_SERVICE_TOKEN in apps/api/.dev.vars) the admin panel can
 * be opened without a Clerk admin account. Production builds never read it —
 * the API remains the security boundary either way.
 */
const devAdminToken: string | undefined = import.meta.env.DEV ? import.meta.env.VITE_ADMIN_SERVICE_TOKEN : undefined;
export const isAdminPreview = Boolean(devAdminToken);

export const { api, setTokenGetter } = createApiClient(import.meta.env.VITE_API_URL ?? '/api', {
  extraHeaders: () => (devAdminToken ? { 'X-Admin-Token': devAdminToken } : undefined),
});
